import { combineReducers, ReducersMapObject } from "redux";
import { plantHalts } from "./plantHalts";

const reducersMap: ReducersMapObject = {
  plantHalts
};

export default combineReducers(reducersMap);
